import React, { useRef, useCallback, useEffect } from 'react';
import { Growl } from 'primereact/growl';
import { Button } from 'primereact/button';
import useInterval from '../../hooks/useInterval';
import { api } from '../../services/contratoApi';
import moment from 'moment';
import { criptoLocalStorage, decriptoLocalStorage } from '../../modulos/cripotografia/criptoStorage';

const AvisoNovo = () => {
    const mensagemNovoAviso = useRef(null);
    const mensagemLogin = useRef(null);
    const fecharMensagemNovoAviso = () => {
        mensagemNovoAviso.current.clear();
    };

    const fecharMensagemLogin = () => {
        mensagemLogin.current.clear();
    };

    // * Customização dos toasts de novo aviso
    const mostrarMensagemNovoAviso = () => {
        const summary = <span>Você tem um novo aviso</span>;
        const detail = (
            <div>
                <span>Clique no botão abaixo para visualizar.</span>
                <div className="wrapper-botoes">
                    <Button
                        label="Verificar"
                        className="p-button-info"
                        onClick={redirectPaginaAvisos}
                    />
                    <Button
                        label="Fechar"
                        className="p-button-danger"
                        onClick={fecharMensagemNovoAviso}
                    />
                </div>
            </div>
        );

        mensagemNovoAviso.current.show({
            severity: 'warn',
            summary,
            detail,
            sticky: true
        });
    };

    const mostrarMensagemLogin = () => {
        const summary = <span>Olá, seja bem-vindo</span>;
        const detail = (
            <div>
                <span>Você pode ter novos avisos. Deseja verificar?</span>
                <div className="wrapper-botoes">
                    <Button
                        label="Verificar"
                        className="p-button-info"
                        onClick={redirectPaginaAvisos}
                    />
                    <Button
                        label="Fechar"
                        className="p-button-danger"
                        onClick={fecharMensagemLogin}
                    />
                </div>
            </div>
        );

        mensagemLogin.current.show({
            severity: 'info',
            summary,
            detail,
            sticky: true
        });
    };

    const redirectPaginaAvisos = () => {
        window.location.href = '/avisos';
    };

    /**  Função que verifica a data do último aviso
     e se a diferença entre a data atual e a data do último aviso
     for maior que 1 dia dispara o toast*/

    const avisoLogin = useCallback(() => {
        const avisoExibido = decriptoLocalStorage('avisoExibido');
        const dataUltimoAviso = decriptoLocalStorage('dataUltimoAviso')?.decriptoValue;

        const dataUltimoAvisoNull =
            !dataUltimoAviso ?
                moment().format('YYYY-MM-DD') :
                dataUltimoAviso.split('T')[0];
        const dataAtual = moment().format('YYYY-MM-DD');
        const dataInicial = moment(dataUltimoAvisoNull, 'YYYY-MM-DD');
        const dataFinal = moment(dataAtual, 'YYYY-MM-DD');
        const diasDiferenca = dataFinal.diff(dataInicial, 'days');

        if (diasDiferenca >= 1 && avisoExibido !== 'true') {
            mostrarMensagemLogin();
            setTimeout(() => {
                criptoLocalStorage('avisoExibido', 'true');
            }, 10000);
        }
    }, []);

    // * Função que seta o ID do ultimo aviso no LocalStorage e verifica se ele é diferente do anterior
    const setIDUltimoAviso = useCallback(async () => {
        const ultimoAviso = decriptoLocalStorage('IdUltimoAviso')?.decriptoValue;
        const { data } = await api.get('/avisos/');

        criptoLocalStorage('IdUltimoAviso', data[data.length - 1].Id_mess);
        criptoLocalStorage('dataUltimoAviso', data[data.length - 1].Data_Criacao);

        const idAvisoAtual = await data.pop().Id_mess;

        if (idAvisoAtual !== Number(ultimoAviso)) {
            return mostrarMensagemNovoAviso();
        }
    }, []);

    const intervaloChamadaAvisos = dataHoraCorrente => {
        const dataHoraUltimoAviso = decriptoLocalStorage('dataHoraDoAviso');
        const dataHoraInicial = moment(dataHoraUltimoAviso, 'DD/MM/YYYY hh:mm:ss');
        const dataHoraFinal = moment(dataHoraCorrente, 'DD/MM/YYYY hh:mm:ss');
        const diferencaDataHora = dataHoraFinal.diff(dataHoraInicial, 'minutes');

        if (diferencaDataHora >= 120) {
            setIDUltimoAviso();
            criptoLocalStorage('dataHoraDoAviso', dataHoraCorrente);
            criptoLocalStorage('avisoExibido', 'true');
        }
    };

    const intervaloEntreChamadasAvisos = () => {
        const dataHoraAtual = moment().format('DD/MM/YYYY HH:mm:ss');

        intervaloChamadaAvisos(dataHoraAtual);
    };

    // Custom Hook que executa uma função de acordo com o dalay (em milisegundos) passado como parâmetro
    useInterval(intervaloEntreChamadasAvisos, 180000); // 3 minutos em milisegundos

    useEffect(() => {
        avisoLogin();
    }, []);

    return (
        <>
            <Growl
                ref={mensagemNovoAviso}
                position="bottomright"
                className="mensagem-novo-aviso"
            />
            <Growl
                ref={mensagemLogin}
                position="bottomright"
                className="mensagem-novo-aviso"
            />
        </>
    );
};

export default AvisoNovo;
